/* eslint-disable newline-before-return */
import { ChangeEvent, FC, useState } from 'react';
import {
  Grid,
  TextArea,
  Button,
  Container,
  Popup,
  // Checkbox,
} from 'semantic-ui-react';
import { chat } from '../../util/index';

const defaultText =
  ' \
空港で必要な日常英会話の例文を10個教えてください。\n \
以下のフォーマットに従って出力してください\n \
```text \n \
日本語訳<改行>\n \
英文<改行>\n \
英文<改行>\n \
```\n \
英語を二回表示している点に注意してください。このフォーマットは英語のリスニング教材で使用することを意図しており、英文は二回再生する必要があります。\n \
また、ダブルクォーテーション、鉤括弧は除去してください。\n \
また、固有名詞や具体的な数値は任意の値を記述してください。\n \
また、結果がコピーしやすいよう、text形式のシンタックスハイライトを用いてください。\n \
また、日本語訳、英文以外は何も出力しないでください。例えば、「日本語：」のようなタイトル表記や、「1.」のような番号表記は不要です。 \
また、```text の文字列の表示も不要です。 \
';

const Component: FC = () => {
  const [text, setText] = useState('');
  const [statusText, setStatusText] = useState('ここに結果が表示されます');
  const [body, setBody] = useState('');

  const copyToClipboard = async () => {
    await global.navigator.clipboard.writeText(statusText);
  };

  const getMessage = async () => {
    setStatusText('Now thinking...');
    setBody('');
    const result = await chat(text);
    if (result) {
      setStatusText(result);
    }
  };
  return (
    <>
      <Grid>
        <Grid.Row columns="equal">
          <Grid.Column width={8}>
            <TextArea
              placeholder=""
              style={{ minHeight: 300, width: '100%' }}
              onChange={(event: ChangeEvent<HTMLTextAreaElement>) => {
                setText(event.target.value);
              }}
            />
          </Grid.Column>
          <Grid.Column width={8}>
            <TextArea
              disabled
              value={body}
              placeholder={statusText}
              style={{ minHeight: 300, width: '100%' }}
            />
            <Container style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Popup
                content="Copied!"
                on="click"
                trigger={
                  <Button
                    icon="copy"
                    size="small"
                    onClick={copyToClipboard}
                    style={{
                      position: 'absolute',
                      bottom: '1em',
                      right: '2em',
                    }}
                  />
                }
              />
            </Container>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row columns="equal">
          <Button
            content="質問"
            disabled={text === '' || statusText === 'Now thinking...'}
            color="blue"
            onClick={getMessage}
          />
        </Grid.Row>
      </Grid>
      <br />
      <p>例文:</p>
      <div style={{ color: 'gray' }}>
        <code>{defaultText}</code>
      </div>
    </>
  );
};

export default Component;
